import { render, staticRenderFns } from "./voteStatusComp.vue?vue&type=template&id=6afec271&scoped=true"
import script from "./voteStatusComp.vue?vue&type=script&lang=js"
export * from "./voteStatusComp.vue?vue&type=script&lang=js"
import style0 from "./voteStatusComp.vue?vue&type=style&index=0&id=6afec271&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afec271",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afec271')) {
      api.createRecord('6afec271', component.options)
    } else {
      api.reload('6afec271', component.options)
    }
    module.hot.accept("./voteStatusComp.vue?vue&type=template&id=6afec271&scoped=true", function () {
      api.rerender('6afec271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/components/voteStatusComp.vue"
export default component.exports